module.exports = __webpack_public_path__ + "static/media/offer-ru-1.a528bc3b.jpg";